import { observer } from 'mobx-react';
import { QuoteComplete } from '../quoteComplete/quoteComplete'

export const QuoteCompleteStep = observer(({ store, substep }) => {
  return <QuoteComplete store={store} />
});